import { SaveData } from "../models/SaveData";

declare const config: { API_URL: string };

export const API_URL = (config && config.API_URL) || "http://localhost:8085/tt-rest";

export const LOGIN_USER_URL = "/EAktywni/login";
export const REMIND_PASSWORD_USER_URL = (facilityIds: string) =>
  `/EAktywni/user/data/reset/password?objectIds=${facilityIds}`;
export const CREATE_NEW_USER_URL = (facilityIds: string) => `/EAktywni/create/webUser?objectIds=${facilityIds}`;
export const GET_USER_DATA_URL = (facilityIds: string) => `/EAktywni/user/data?objectIds=${facilityIds}`;
export const GET_USER_TICKETS_URL = (facilityIds: string) => `/EAktywni/user/passes?facilityIds=${facilityIds}`;
export const USER_CHANGE_PASS_URL = (facilityIds: string) => `/EAktywni/user/data/password?objectIds=${facilityIds}`;
export const USER_EDIT_DATA_URL = (facilityIds: string) => `/EAktywni/user/data/edit?objectIds=${facilityIds}`;
export const GET_ZONE_SCHEME_URL = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercises/zoneScheme?facilityIds=${facilityIds}&exerciseIds=${exerciseIds}`;
export const GET_TICKETS_MOVIE_URL = (facilityIds: string, exerciseIds: string) =>
  `/EAktywni/exercises/zoneScheme/tickets?facilityIds=${facilityIds}&exerciseIds=${exerciseIds}`;
export const FAKE_LOGIN_USE_URL = "/EAktywni/session/fake";
export const ADD_TO_BASKET_URL = "/EAktywni/addTicket";
export const ASSIGN_ASSORT_TO_BASKET_URL = "/EAktywni/assignAssort";
export const CLEAR_BASKET_URL = (facilityIds: string) => `/EAktywni/clearbasket?objectIds=${facilityIds}`;
export const GET_BASKET_URL = `/EAktywni/basket`;
export const REMOVE_ITEM_BASKET_URL = `/EAktywni/removeTicket`;
export const ACCEPT_TRANSACTION_URL = (data: SaveData) =>
  `/EAktywni/saveReservation?name=${data.firstName}&lastName=${data.lastName}&email=${data.email}&phone=${data.phone}&companyName=${data.companyName}&NIP=${data.NIP}&street=${data.street}&city=${data.city}&houseNumber=${data.houseNumber}&flatNumber=${data.flatNumber}&zipCode=${data.zipCode}&createInvoice=${data.createInvoice}&createUser=${data.createUser}`;
export const GET_SHOWS = (facilityIds: string, date?: string) => {
  if (date) {
    return `/EAktywni/shows?facilityIds=${facilityIds}&date=${date}`;
  }
  return `/EAktywni/shows?facilityIds=${facilityIds}`;
};

export const BLOCK_SEAT_URL = "/EAktywni/blockSeat";
export const UNBLOCK_SEAT_URL = "/EAktywni/unblockSeat";
export const ASSORT_GROUP_BY_FACILITY_URL = (facilityIds: string) =>
  `/EAktywni/sort/assortGroups?objectIds=${facilityIds}`;
export const GET_FOOD_LIST_URL = (facilityIds: string, assortGroupIds: string) =>
  `/EAktywni/facility/goods?objectIds=${facilityIds}&assortGroupIds=${assortGroupIds}`;
export const GET_CONF_FACILITY = (facilityIds: string) =>
  `/EAktywni/facility/configuration/byIds?objectIds=${facilityIds}`;
